export function roundUpSecondsToMinutes(seconds: number): number {
  return Math.ceil(seconds / 60);
}

export function roundSecondsToMinutes(seconds: number): number {
  return Math.ceil(seconds / 60);
}
